import { ExternalType } from "./type.js";
import { externalFactory } from "./externalFactory.js";
import { createOrderFileTaskV2 } from "./caxa/directive/createOrderFileTaskV2.js";
import { kjlRequest } from "./kujiale/initKujiale.js";
const externalCreateOrderFileTaskV2 = externalFactory(async (params) => {
  const { type, taskId } = params;
  switch (type) {
    case ExternalType.caxa:
      return await createOrderFileTaskV2(params.arg, params.sequenceId, params.socketNext);
    case ExternalType.kujiale:
      return await kjlRequest.splitOrder(params.arg, params.sequenceId);
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
});
export { externalCreateOrderFileTaskV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalCreateOrderFileTaskV2.js